<template>
  <main>
    <div style="background-color: white">
      <div class="showUs">
        <div class="content">
          <div>
            <div class="icon">
              <img src="@/assets/images/Home/start-2.png">
              <span>{{ $t('services.collection.icon') }}</span>
            </div>

            <div class="textContent">
              <div>
                <h3>{{ $t('services.collection.heroTitle') }}</h3>
                <p v-html="$t('services.collection.heroBody')"></p>
                <div class="action">
                  <a class="button" :href="`${this.clientUrl}/auth/register`" target="_blank">
                    <span>{{ $t('common.startNow') }}</span>
                    <div class="arrowBox">
                      <span class="arrow">
                        <i /><i /><i />
                      </span>
                    </div>
                  </a>
                  <router-link class="button" to="/customer" target="_blank">
                    <span>{{ $t('common.contactUs') }}</span>
                    <span class="arrow">
                      <i /><i /><i />
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <svg class="circleBg" width="750" height="521">
            <circle data-v-7e34ff45="" r="375" cx="375" cy="376" stroke-width="2" fill="none" stroke="#D9E1E8" stroke-dasharray="8"></circle>
            <circle data-v-7e34ff45="" r="305" cx="375" cy="376" stroke-width="2" fill="none" stroke="#D9E1E8" stroke-dasharray="8"></circle>
            <circle data-v-7e34ff45="" r="235" cx="375" cy="376" stroke-width="2" fill="none" stroke="#D9E1E8" stroke-dasharray="8"></circle>
          </svg>

          <div class="phone">
            <img src="@/assets/images/Services/collection/phone1.png">
            <img src="@/assets/images/Services/collection/phone2.png">
            <img src="@/assets/images/Services/collection/phone3.png">
            <img src="@/assets/images/Services/collection/phone4.png">

            <div class="svgLine">
              <svg  width="190" height="190" viewPort="0 0 120 120" version="1.1">
                <defs>
                  <linearGradient id="grad" x1="0%" y1="100%" x2="100%" y2="100%">
                    <stop offset="0" stop-color="#EA80FD" />
                    <stop offset="1" stop-color="#3023AD" />
                  </linearGradient>
                </defs>
                <rect class="line" stroke-width="2" stroke-dasharray="8" x="10" y="10" rx="25" ry="25" width="250" height="250" stroke="url('#grad')" fill="none" ></rect>
                <circle r="7" cx="10" cy="182" stroke-width="2" fill="#F6F9FC" stroke="#E980FD"></circle>
                <polyline points="175,17 175,2 191 9.5" fill="#3123AE" ></polyline>
              </svg>
            </div>

            <div class="svgLine_right">
              <svg  width="220" height="100" viewPort="0 0 120 120" version="1.1">
                <defs>
                  <linearGradient id="grad" x1="100%" y1="100%" x2="0%" y2="100%">
                    <stop offset="0" stop-color="#EA80FD" />
                    <stop offset="1" stop-color="#3023AD" />
                  </linearGradient>
                </defs>
                <rect class="line" stroke-width="2" stroke-dasharray="8" x="-45" y="-158" rx="25" ry="25" width="250" height="250" stroke="url('#grad')" fill="none" ></rect>
                <circle r="7" cx="8" cy="92" stroke-width="2" fill="#F6F9FC" stroke="#E980FD"></circle>
                <polyline points="197,15 213,15 205 -1" fill="#3123AE" ></polyline>
              </svg>
            </div>

          </div>
        </div>
      </div>

      <div class="open content">
        <div class="textAndList">
          <h3>{{ $t('services.collection.openTitle') }}</h3>
          <p v-html="$t('services.collection.openBody')"></p>

          <ul>
            <li v-for="(item, index) in openItems" :key="item.title">
              <img :src="openIcons[index]" alt="Open" />
              <span>{{ item.title }}</span>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>

        <div class="images">
          <img src="@/assets/images/Services/collection/point.png"/>
          <img src="@/assets/images/Services/collection/open_account1.png"/>
          <img src="@/assets/images/Services/collection/open_account2.png"/>
        </div>
      </div>

      <div class="account content">
        <div class="textAndList">
          <h3>{{ $t('services.collection.accountTitle') }}</h3>
          <p v-html="$t('services.collection.accountBody')"></p>
          <ul>
            <li v-for="(item, index) in accountItems" :key="item.title">
              <img :src="accountIcons[index]" alt="Open" />
              <span>{{ item.title }}</span>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>

        <div class="images">
          <img src="@/assets/images/Services/collection/account1.png">
          <img src="@/assets/images/Services/collection/point.png"/>
          <img src="@/assets/images/Services/collection/account2.png">
        </div>
      </div>

      <div class="shop content">
        <div class="textAndList">
          <h3>{{ $t('services.collection.shopTitle') }}</h3>
          <p v-html="$t('services.collection.shopBody')"></p>
          <ul>
            <li v-for="(item, index) in shopItems" :key="item.title">
              <img :src="shopIcons[index]" alt="Open" />
              <span>{{ item.title }}</span>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>

        <div class="images">
          <img src="@/assets/images/Services/collection/shop1.png">
          <img src="@/assets/images/Services/collection/shop2.png">
          <img src="@/assets/images/Services/collection/shop3.png">
          <img src="@/assets/images/Services/collection/point.png"/>
        </div>
      </div>

      <div class="process">
        <div class="content">
          <div class="textAndList">
            <h3>{{ $t('services.collection.processTitle') }}</h3>
            <p v-html="$t('services.collection.processBody')"></p>

            <ul>
              <li v-for="(item, index) in processItems" :key="item.title">
                <img :src="processIcons[index]" alt="Collection" />
                <span>{{ item.title }}</span>
                <p v-html="item.desc"></p>
              </li>
            </ul>
          </div>
          <div>
            <img src="@/assets/images/Payment/register1.png">
            <img src="@/assets/images/Payment/register2.png">
          </div>

        </div>
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    name: 'Acquiring',
    data() {
      return {
        stopSrc: '',
        height: window.innerHeight,
        openIcons: [
          require('@/assets/images/Services/open-1.png'),
          require('@/assets/images/Services/open-2.png'),
        ],
        accountIcons: [
          require('@/assets/images/Services/account-1.png'),
          require('@/assets/images/Services/account-2.png'),
        ],
        shopIcons: [
          require('@/assets/images/Services/shop-1.png'),
          require('@/assets/images/Services/shop-2.png'),
        ],
        processIcons: [
          require('@/assets/images/Services/register.png'),
          require('@/assets/images/Services/binding.png'),
          require('@/assets/images/Services/collection.png'),
        ],
      }
    },
    computed: {
      openItems() {
        return this.$t('services.collection.openItems');
      },
      accountItems() {
        return this.$t('services.collection.accountItems');
      },
      shopItems() {
        return this.$t('services.collection.shopItems');
      },
      processItems() {
        return this.$t('services.collection.processItems');
      },
    },
    mounted() {

    },
    destroyed() {
      window.onresize = null;
    }
  }
</script>

<style lang="less" scoped>
  .bodyFont(@bodyFontSize: 18px, @bodyLineHeight: 1.555555556, @fontWeightNormal: 300) {
    font: @fontWeightNormal @bodyFontSize/@bodyLineHeight "sohne-var", "Helvetica Neue", "Arial", sans-serif;
  }

  .button {
    height: auto;
    padding: 3px 0 6px;
    line-height: 1.6;
    .bodyFont(15px, 1.6, 425);
  }

  .showUs {
    background: #F6F9FC;
    padding: 112px 0 72px;
    .content {
      min-height: 577px;
      & > div {
        .icon {
          display: flex;
          align-items: center;
          height: 52px;
          & > img {
            width: 52px;
            margin-right: 20px;
          }
          & > span {
            display: flex;
            justify-content: center;
            font-size: 18px;
            font-weight: 500;
            color: #082440;
            line-height: 27px;
          }
        }

        .textContent {
          display: flex;

          & > div {
            width: 560px;
            margin-top: 72px;
            & > h3 {
              max-width: 520px;
              font-size: 48px;
              font-weight: 500;
              color: #082440;
              line-height: 58px;
            }

            & > p {
              width: 500px;
              margin-top: 30px;
              color: #082440;
              font-weight: 200;
              font-size: 20px;
              line-height: 36px;
              & > span {
                color: var(--spanColor1);
              }
            }

            .action {
              display: flex;
              margin-top: 30px;
              .button {
                width: 122px;
                margin-right: 20px;
                background: #0070FF;

                &:first-child:hover {
                  background: #0A2540;
                }

                &:last-child {
                  width: auto;
                  background: none;
                  color: #0070FF;

                  .arrow > i {
                    background: #0070FF;
                  }
                }
              }
            }
          }
        }
      }

      .circleBg {
        position: absolute;
        bottom: 24px;
        right: -60px;
        transform: scale(0.9);
        transform-origin: right bottom;
      }

      .phone {
        position: absolute;
        width: 418px;
        height: 734px;
        right: 30px;
        bottom: -220px;
        transform: scale(0.92);
        transform-origin: right bottom;
        & > img {
          height: 734px;
          z-index: 10;
          &:nth-child(2) {
            position: absolute;
            height: 55px;
            top: 380px;
            left: -140px;
          };
          &:nth-child(3) {
            position: absolute;
            height: 35px;
            top: 265px;
            left: -105px;
          };
          &:nth-child(4) {
            position: absolute;
            height: 55px;
            top: 118px;
            right: -140px;
          }
        }

        .svgLine {
          display: flex;
          position: absolute;
          left: -80px;
          top: 188px;
          .line {
            stroke-dashoffset: 0;
            animation: draw 10s linear infinite;
          }
          @keyframes draw {
            from {
              stroke-dashoffset: 400;
            }
          }
        }

        .svgLine_right {
          display: flex;
          position: absolute;
          right: -80px;
          top: 190px;
          z-index: 15;
          .line {
            stroke-dashoffset: 400;
            animation: draw_right 10s linear infinite;
          }
          @keyframes draw_right {
            from {
              stroke-dashoffset: 0;
            }
          }
        }
      }
    }
  }

  .textAndList {
    & > span {
      font-size: 36px;
      font-weight: 400;
      color: #082440;
      line-height: 54px;
    }
    & > p {
      width: 480px;
      font-size: 20px;
      font-weight: 200;
      color: #092641;
      line-height: 36px;
      & > span {
        color: var(--spanColor1);
      }
    }

    & > ul {
      display: flex;
      padding: 0;
      margin-top: 59px;
      & > li {
        margin-right: 55px;
        & > img {
          height: 40px;
        }

        & > span {
          display: block;
          position: relative;
          font-size: 16px;
          font-weight: bold;
          color: #082440;
          line-height: 16px;
          margin-top: 20px;

          &:before {
            position: absolute;
            left: -15px;
            width: 1px;
            height: 15px;
            content: '';
            background: #0070FF;
          }
        }
        & > p {
          width: 240px;
          font-size: 16px;
          font-weight: 200;
          color: #092641;
          line-height: 24px;
          margin-top: 10px;
          & > span {
            color: var(--spanColor1);
          }
        }
      }
    }
  }

  .open {
    padding: 266px 0 0 0;
    display: flex;
    justify-content: space-between;
    .textAndList {
      margin-top: 71px;
    }
    .images {
      position: relative;
      margin-right: -50px;

      & > img {
        width: 596px;
        &:nth-child(2) {
          position: absolute;
          top: -67px;
          left: 140px;
          width: 693px;
          border-radius: 16px;
          box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
        }
        &:nth-child(3) {
          position: absolute;
          top: 73px;
          left: -38px;
          width: 296px;
          border-radius: 16px;
          box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
        }
      }
    }
  }

  .showFeatures {
    display: flex;
    justify-content: space-between;
    & > div {
      margin-top: 43px;
      & > span {
        font-size: 28px;
        font-weight: 400;
        color: #0070FF;
        line-height: 41px;
        margin-bottom: 13px;
      }
      & > p {
        width: 480px;
        font-size: 20px;
        font-weight: 200;
        color: #092641;
        line-height: 36px;
        margin-bottom: 30px;
        & > span {
          color: #0070FF;
          font-weight: 400;
        }
      }
      & > ul {
        list-style: none;
        & > li {
          display: flex;
          align-items: center;
          font-size: 20px;
          font-weight: 200;
          color: #092641;
          line-height: 29px;
          margin-bottom: 12px;
          & > div {
            border: 3px solid rgba(83, 226, 177, 0.33);
            border-radius: 8px;
            margin-right: 10px;
            & > div {
              padding: 3px;
              background: #0BEA82;
              border-radius: 8px;
            }
          }
        }
      }
    }
    & > img {
      width: 592px;
      border-radius: 16px;
      box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
    }
  }
  .account {
    padding: 245px 0 0 0;
    display: flex;
    justify-content: space-between;

    .textAndList {
      margin-top: 101px;
    }

    .images {
      position: relative;
      & > img {
        width: 528px;
        border-radius: 16px;
        box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
        &:nth-child(2) {
          position: absolute;
          height: 312px;
          bottom: -50px;
          right: -129px;
          z-index: -1;
          border-radius: 0;
          box-shadow: none;
        }
        &:nth-child(3) {
          position: absolute;
          top: 214px;
          left: -80px;
          width: 398px;
          border-radius: 0;
          box-shadow: none;
        }
      }
    }
  }

  .shop {
    padding: 350px 0 294px 0;
    display: flex;
    justify-content: space-between;
    .textAndList {
      margin-top: 98px;
    }
    .images {
      position: relative;
      & > img {
        width: 528px;
        border-radius: 20px;
        box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
        &:nth-child(2) {
          position: absolute;
          width: 270px;
          bottom: -116px;
          right: -63px;
        }
        &:nth-child(3) {
          position: absolute;
          bottom: -70px;
          left: 98px;
          width: 202px;
          border-radius: 0;
          box-shadow: none;
        }
        &:last-child {
          position: absolute;
          bottom: -160px;
          left: 80px;
          width: 362px;
          border-radius: 0;
          box-shadow: none;
          z-index: -1;
        }
      }
    }
  }

  .process {
    padding: 142px 0 0;
    background: #F6F9FC;
    overflow: hidden;
    .content {
      display: flex;
      justify-content: space-between;
      & > div {
        position: relative;
        right: 0;
        bottom: -20px;
        & > img {
          width: 296px;
          border-radius: 12px;
          box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
          &:last-child {
            position: absolute;
            top: 57px;
            left: 47px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .showUs {
      padding: 72px 0 40px;

      .content {
        min-height: auto;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
      }

      .content > div .textContent > div {
        width: auto;
        margin-top: 24px;

        & > h3 {
          max-width: none;
          font-size: 32px;
          line-height: 44px;
        }

        & > p {
          width: auto;
          max-width: none;
          font-size: 18px;
          line-height: 30px;
        }
      }

      .circleBg,
      .phone {
        transform: none;
      }

      .circleBg {
        position: relative;
        right: auto;
        bottom: auto;
        width: 100%;
        max-width: 620px;
        height: auto;
        margin: 16px auto 0;
      }

      .phone {
        position: relative;
        right: auto;
        bottom: auto;
        width: 100%;
        max-width: 418px;
        height: 734px;
        margin: -180px auto 0;
      }
    }

    .open,
    .account,
    .shop,
    .process {
      padding-left: 20px;
      padding-right: 20px;
    }

    .open,
    .account,
    .shop {
      padding-top: 120px;
      padding-bottom: 0;
      align-items: center;
      gap: 32px;

      .textAndList {
        margin-top: 0;
      }

      .images {
        margin-right: 0;
      }
    }

    .textAndList {
      flex: 1;

      & > h3,
      & > span {
        font-size: 30px;
        line-height: 40px;
      }

      & > p {
        width: 100%;
        max-width: 560px;
        font-size: 18px;
        line-height: 30px;
      }

      & > ul {
        flex-wrap: wrap;
        gap: 24px 0;

        & > li {
          width: 50%;
          margin-right: 0;
          padding-right: 24px;

          & > p {
            width: auto;
          }
        }
      }
    }

    .open .images,
    .account .images,
    .shop .images {
      flex: 1;
      min-width: 0;

      & > img:first-child {
        width: 100%;
        max-width: 528px;
      }
    }

    .open .images > img:nth-child(2) {
      width: 120%;
      max-width: 600px;
      left: 72px;
      top: -32px;
    }

    .open .images > img:nth-child(3) {
      width: 42%;
      min-width: 220px;
      top: 56px;
      left: -12px;
    }

    .account .images > img:nth-child(2) {
      right: -40px;
      bottom: -28px;
      height: 220px;
    }

    .account .images > img:nth-child(3) {
      width: 54%;
      max-width: 320px;
      top: 180px;
      left: -30px;
    }

    .shop .images > img:nth-child(2) {
      width: 48%;
      max-width: 240px;
      right: -16px;
      bottom: -82px;
    }

    .shop .images > img:nth-child(3) {
      width: 36%;
      max-width: 180px;
      left: 72px;
      bottom: -48px;
    }

    .shop .images > img:last-child {
      width: 58%;
      max-width: 320px;
      left: 48px;
      bottom: -120px;
    }

    .process {
      padding-top: 120px;

      .content {
        gap: 32px;
        align-items: flex-start;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .showUs {
      padding: 40px 16px 20px;
      overflow: hidden;

      .content {
        min-height: auto;
        padding: 0;

        & > div:first-child {
          width: 100%;
          min-width: 0;

          .icon {
            height: auto;
            justify-content: center;
            margin-bottom: 0;

            & > img {
              width: 32px;
              margin-right: 8px;
            }

            & > span {
              font-size: 14px;
              line-height: 20px;
            }
          }

          .textContent {
            display: block;
            width: 100%;

            & > div {
              width: 100%;
              margin-top: 24px;

              & > h3 {
                max-width: none;
                margin-bottom: 10px;
                font-size: 24px;
                line-height: 1.25;
                text-align: center;
              }

              & > p {
                width: auto;
                max-width: none;
                margin-top: 0;
                margin-bottom: 20px;
                font-size: 15px;
                line-height: 1.6;
                text-align: left;
              }

              .action {
                flex-direction: column;
                align-items: center;
                gap: 12px;
                margin-top: 0;

                .button {
                  width: 100%;
                  max-width: 320px;
                  margin: 0;

                  &:last-child {
                    width: 100%;
                    max-width: 320px;
                  }
                }
              }
            }
          }
        }
      }

      .circleBg {
        display: none;
      }

      .phone {
        display: none;
      }
    }

    .open,
    .account,
    .shop,
    .process {
      padding-left: 16px;
      padding-right: 16px;
    }

    .open,
    .account,
    .shop {
      flex-direction: column;
      gap: 24px;
      padding-top: 88px;
    }

    .textAndList {
      & > h3,
      & > span {
        font-size: 26px;
        line-height: 34px;
      }

      & > p {
        font-size: 16px;
        line-height: 28px;
      }

      & > ul {
        margin-top: 32px;
        gap: 20px;

        & > li {
          width: 100%;
          padding-right: 0;

          & > span {
            margin-top: 16px;
          }
        }
      }
    }

    .open .images,
    .account .images,
    .shop .images {
      width: 100%;
    }

    .open .images > img:nth-child(2) {
      position: absolute;
      width: 88%;
      left: 12%;
      top: -18px;
    }

    .open .images > img:nth-child(3) {
      width: 42%;
      min-width: 0;
      left: -6px;
      top: 44px;
    }

    .account .images > img:nth-child(2) {
      height: 160px;
      right: -20px;
      bottom: -18px;
    }

    .account .images > img:nth-child(3) {
      width: 52%;
      top: 108px;
      left: -12px;
    }

    .shop {
      padding-bottom: 112px;
    }

    .shop .images > img:nth-child(2) {
      width: 44%;
      right: -6px;
      bottom: -54px;
    }

    .shop .images > img:nth-child(3) {
      width: 34%;
      left: 52px;
      bottom: -36px;
    }

    .shop .images > img:last-child {
      width: 52%;
      left: 34px;
      bottom: -76px;
    }

    .process {
      padding-top: 88px;

      .content {
        flex-direction: column;
        gap: 24px;

        & > div:last-child {
          width: 100%;
          padding-bottom: 180px;

          & > img {
            width: 72vw;
            max-width: 296px;

            &:last-child {
              left: auto;
              right: 0;
              top: 42px;
            }
          }
        }
      }
    }
  }
</style>
